import "core-js/modules/es.array.is-array.js";
import React, { createContext } from 'react';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var BackgroundContext = /*#__PURE__*/createContext({
  backgroundColor: undefined,
  isBackgroundGradient: false
});
export var BackgroundProvider = function BackgroundProvider(_ref) {
  var backgroundColor = _ref.backgroundColor,
    children = _ref.children;
  return _jsx(BackgroundContext.Provider, {
    value: {
      backgroundColor: backgroundColor,
      isBackgroundGradient: Array.isArray(backgroundColor)
    },
    children: children
  });
};